
import extend from './extend';
import bottle from './bottle';

// eslint-disable-next-line prefer-destructuring
const TerminusDrilldownContainer = bottle().container.TerminusDrilldownContainer;

export default extend(TerminusDrilldownContainer);
